import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

const BasePageFooter = ({ opacity = 0.95, hideBorder = true, height, isHomePage = false, children }: PropsWithChildren<{ opacity?: number, hideBorder?: boolean, height?: number, isHomePage?: boolean }>) => {
  return <div>
    <BoxContainer>
      <Inner $opacity={opacity} $hideBorder={hideBorder} $height={height} $isHomePage={isHomePage}>
        {children}
      </Inner>
    </BoxContainer>
  </div>;
};

export const Inner = styled.div<{ $opacity: number, $hideBorder?: boolean, $height?: number, $isHomePage: boolean }>`
  display: flex;
  justify-content: center;
  ${({ $height }) => $height !== undefined ? `height: ${$height}px;` : ''}
  align-items: center;
  flex-direction: ${({ $isHomePage }) => $isHomePage ? 'column' : 'unset'};;
  background: ${({ $opacity }) => `rgba(255, 255, 255, ${$opacity})`};
  width: 100%;
  ${({ $hideBorder = false }) => $hideBorder ? '' : 'border-top: 1px solid #E0E0E0;'}
  z-index: 100;
  position: relative;
`;

const BoxContainer = styled.div`
  flex-direction: column;
  position: relative;
  width: 100vw;
  border-top: 1pt solid rgba(255, 255, 255, 0.37);
`;

export const FooterButtonWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  gap: 10px;
  margin: 10px 0;
  width: 600px;
  max-width: calc(100% - 20px);
`;

export default BasePageFooter;


